import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import CustomerSelector from "./customer-selector";
import UserMenuTopBar from "./user-menu";
import LanguageSelector from "./language-selector";
import CustomerSelectorV2 from "./customer-selector-v2";
import axios from "axios";
import { 
  getUserCustomerAccess, 
  getDefaultCustomer, 
  setActiveCustomer 
} from "../../../../../_metronic/helpers/UserRoleHelpers";

export default function TopBar() {
  const { user } = useAuth0();

  const [customer, setCustomer] = useState("");
  const [isKonfidencyAdmin, setIsKonfidencyAdmin] = useState(false);

  const history = useHistory();

  function onCustomerSelected(e: React.ChangeEvent<HTMLSelectElement>) {
    setActiveCustomer(e.target.value);
    history.go(0);
  }

  useEffect(() => {
    if (user) {
      const access = getUserCustomerAccess(user);
      const defaultCustomer = getDefaultCustomer(user);

      if (defaultCustomer) {
        setCustomer(defaultCustomer);
        // Ensure localStorage is set
        if (!window.localStorage.getItem("activeCustomer")) {
          setActiveCustomer(defaultCustomer);
        }
      }

      setIsKonfidencyAdmin(access.isKonfidencyAdmin);
    }
  }, [user]);

  useEffect(() => {
    if (user && customer) {
      axios.get(`/user/crisp-id`).then((response) => {
        if (!response) {
          console.error("Failed to fetch Crisp ID");
          return;
        }
        (window as any).CRISP_TOKEN_ID  = user.sub;
        (window as any).$crisp.push(["set", "user:email", [user?.email, response.data]]);
        (window as any).$crisp.push(["set", "session:data", [[
          ["customer", customer]
        ]]]);
        (window as any).$crisp.push(["set", "user:company", [customer]]);

        (window as any).$crisp.push(["on", "session:loaded", function() {
          // Reenvia o email quando uma nova sessão é criada
          (window as any).$crisp.push(["set", "user:email", [user?.email, response.data]]);
        }]);

      });
      // axios.get("/user/intercom-id").then((response) => {
      //   if (!response) {
      //     console.error("Failed to fetch Intercom token");
      //     return;
      //   }
      //   (window as any).intercomSettings = {
      //     app_id: "b5yhlscr",
      //     intercom_user_jwt: response.data,
      //     user_id: user.sub,
      //     name: user?.name,
      //     email: user?.email,
      //     company: {
      //       company_id: customer,
      //       name: customer,
      //     },
      //   };
      //   try {
      //     (window as any).loadIntercom();
          
      //     // Verificar se o Intercom criou algum iframe problemático
      //     setTimeout(() => {
      //       const intercomIframes = document.querySelectorAll('iframe[src*="intercom"]');
      //       intercomIframes.forEach((iframe) => {
      //         const style = window.getComputedStyle(iframe);
      //         if (style.position === 'fixed' && style.zIndex === '2147483647') {
      //           console.warn('Intercom iframe com z-index problemático detectado:', iframe);
      //           // Corrigir z-index em vez de remover
      //           (iframe as HTMLElement).style.zIndex = '1000';
      //           console.log('Z-index do Intercom corrigido para 1000');
      //         }
      //       });
      //     }, 1000);
          
      //   } catch (err) {
      //     console.log("error setting customer on intercom chat");
      //   }
      // });

      if ((window as any).clarity) {
        (window as any).clarity  = (window as any).clarity || function () {
          ((window as any).clarity.q = (window as any).clarity.q || []).push(arguments);
        };


        (window as any).clarity("event", "identified_customer");
        (window as any).clarity("set", "customer", customer);
      }
    }
  }, [user, customer]);

  return (
    <div className="d-flex align-items-stretch flex-shrink-0">
      {!isKonfidencyAdmin && (
        <CustomerSelector
          selectedCustomer={customer}
          user={user}
          onChange={onCustomerSelected}
        />
      )}

      {isKonfidencyAdmin && (
        <CustomerSelectorV2
          selectedCustomer={customer}
          user={user}
          onChange={onCustomerSelected}
        />
      )}

      <LanguageSelector />
      <UserMenuTopBar user={user} />
    </div>
  );
}
